// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IInstrumentDto
 */
export interface IInstrumentDto {
    /**
     * 
     * @type {number}
     * @memberof IInstrumentDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IInstrumentDto
     */
    external_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IInstrumentDto
     */
    symbol?: string;
    /**
     * 
     * @type {string}
     * @memberof IInstrumentDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IInstrumentDto
     */
    research_url?: string;
    /**
     * 
     * @type {string}
     * @memberof IInstrumentDto
     */
    image_url?: string;
    /**
     * 
     * @type {string}
     * @memberof IInstrumentDto
     */
    instrument_category_type?: IInstrumentDtoInstrumentCategoryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IInstrumentDto
     */
    status?: IInstrumentDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IInstrumentDto
     */
    type?: IInstrumentDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IInstrumentDto
     */
    close?: number;
}

/**
* @export
* @enum {string}
*/
export enum IInstrumentDtoInstrumentCategoryTypeEnum {
    SHORT_TERM_BOND = 'SHORT_TERM_BOND',
    INTERMEDIATE_CORE_BOND = 'INTERMEDIATE_CORE_BOND',
    INTERMEDIATE_CORE_PLUS_BOND = 'INTERMEDIATE_CORE_PLUS_BOND',
    INFLATION_PROTECTED_BOD = 'INFLATION_PROTECTED_BOD',
    GLOBAL_BOND = 'GLOBAL_BOND',
    HIGH_YIELD_BOND = 'HIGH_YIELD_BOND',
    LARGE_VALUE = 'LARGE_VALUE',
    LARGE_BLEND = 'LARGE_BLEND',
    LARGE_GROWTH = 'LARGE_GROWTH',
    MID_CAP_VALUE = 'MID_CAP_VALUE',
    MID_CAP_BLEND = 'MID_CAP_BLEND',
    MID_CAP_GROWTH = 'MID_CAP_GROWTH',
    SMALL_VALUE = 'SMALL_VALUE',
    SMALL_BLEND = 'SMALL_BLEND',
    SMALL_GROWTH = 'SMALL_GROWTH',
    REAL_ESTATE = 'REAL_ESTATE',
    FOREIGN_LARGE_BLEND = 'FOREIGN_LARGE_BLEND',
    FOREIGN_SMALL_MID_BLEND = 'FOREIGN_SMALL_MID_BLEND',
    DIVERSIFIED_EMERGING_MKTS = 'DIVERSIFIED_EMERGING_MKTS',
    MONEY_MARKET_FUND = 'MONEY_MARKET_FUND'
}
/**
* @export
* @enum {string}
*/
export enum IInstrumentDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    CLOSE_ONLY = 'CLOSE_ONLY',
    HALTED = 'HALTED'
}
/**
* @export
* @enum {string}
*/
export enum IInstrumentDtoTypeEnum {
    EQUITY = 'EQUITY',
    ETF = 'ETF',
    ADR = 'ADR',
    ETN = 'ETN',
    ALTERNATIVE_ASSET = 'ALTERNATIVE_ASSET',
    CRYPTO = 'CRYPTO',
    INTEREST_RATE = 'INTEREST_RATE',
    CYBER_SECURITY = 'CYBER_SECURITY',
    METALS = 'METALS',
    MUTUAL_FUND = 'MUTUAL_FUND'
}


/**
 * Check if a given object implements the IInstrumentDto interface.
 */
export function instanceOfIInstrumentDto(value: object): value is IInstrumentDto {
    return true;
}

export function IInstrumentDtoFromJSON(json: any): IInstrumentDto {
    return IInstrumentDtoFromJSONTyped(json, false);
}

export function IInstrumentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInstrumentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'external_id': json['external_id'] == null ? undefined : json['external_id'],
        'symbol': json['symbol'] == null ? undefined : json['symbol'],
        'name': json['name'] == null ? undefined : json['name'],
        'research_url': json['research_url'] == null ? undefined : json['research_url'],
        'image_url': json['image_url'] == null ? undefined : json['image_url'],
        'instrument_category_type': json['instrument_category_type'] == null ? undefined : json['instrument_category_type'],
        'status': json['status'] == null ? undefined : json['status'],
        'type': json['type'] == null ? undefined : json['type'],
        'close': json['close'] == null ? undefined : json['close'],
    };
}

export function IInstrumentDtoToJSON(json: any): IInstrumentDto {
    return IInstrumentDtoToJSONTyped(json, false);
}

export function IInstrumentDtoToJSONTyped(value?: IInstrumentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'external_id': value['external_id'],
        'symbol': value['symbol'],
        'name': value['name'],
        'research_url': value['research_url'],
        'image_url': value['image_url'],
        'instrument_category_type': value['instrument_category_type'],
        'status': value['status'],
        'type': value['type'],
        'close': value['close'],
    };
}

